<div class="field">
  <label *ngIf="showLabel" for="customerBaSelector" class="do-not-wrap-text">{{labelKey}}</label>
  <div class="p-inputgroup">
    <p-dropdown #customerBaSelector

                id="customerBaSelector"
                editable="true"
                class="p-dropdown-filter"
                placeholder="Выбор категории"
                filterPlaceholder="Поиск..."

                [(ngModel)]="productCategory"
                [options]="productGlobalCategories"
                [filter]="true"
                [disabled]="_disabled"
                [virtualScroll]="true"
                [virtualScrollItemSize]="31"

                (onChange)="onChangeCS($event)"
                (onClick)="onClickCS($event)"
                ></p-dropdown>
    <p-button icon="pi pi-plus" styleClass="p-button-success ml-1" (onClick)="onCategoryAddButton($event)" disabled="areaExists"
              pTooltip="Добавить новую категорию" tooltipPosition="top" *ngIf="doShowAddCategoryButton"></p-button>
  </div>
</div>
